/**
 * FRONT-2669 — the Changes toggle and its explanation are ONE decision
 * (FRONT-1670): `disabled` is derived from the reason, so a state can be
 * unavailable only if it has a sentence saying why.
 */
export const NO_EARLIER_VERSION = "No earlier version yet. Changes shows what EDDY's last edit changed.";

export type ChangesAvailability =
  /** Not a document (a Markdown file, which has no version history): the tab is not offered at all. */
  | 'not-a-document'
  /** The document or the last-change answer is still on its way. */
  | 'loading'
  | 'error'
  | 'available'
  | 'unavailable';

export const CHANGES_AVAILABILITIES: readonly ChangesAvailability[] = [
  'not-a-document',
  'loading',
  'error',
  'available',
  'unavailable',
];

/**
 * Why Changes cannot be chosen, or null when it can. Loading and error stay choosable
 * so the person can see them. 'not-a-document' has no tab to disable (a file never
 * shows Changes), so it carries no reason either.
 */
export function changesUnavailableReason(a: ChangesAvailability): string | null {
  return a === 'unavailable' ? NO_EARLIER_VERSION : null;
}

export function changesToggle(a: ChangesAvailability): { disabled: boolean; reason: string | null } {
  const reason = changesUnavailableReason(a);
  return { disabled: reason !== null, reason };
}

/** The availability the view and the toggle share, from the document and its last-change query. */
export function changesAvailability(input: {
  isDocument: boolean;
  isPending: boolean;
  isError: boolean;
  data: { available: boolean } | undefined;
}): ChangesAvailability {
  if (!input.isDocument) return 'not-a-document';
  if (input.isError) return 'error';
  if (input.isPending || !input.data) return 'loading';
  return input.data.available ? 'available' : 'unavailable';
}
